import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/Button";
import { TextInput } from "../components/ui/Field";
import { getDb } from "../db/dexie";
import { getSyncClient } from "../sync/SyncClient";
import { useUnsavedGuard } from "../pwa/unsaved";

export function SettingsCosts() {
  const cost = useLiveQuery(
    () => getDb().cost_profile.filter((c) => c.deletedAt == null).first(),
    [],
  );
  const [diesel, setDiesel] = useState("");
  const [other, setOther] = useState("");
  const [target, setTarget] = useState("");
  const [floor, setFloor] = useState("");

  useEffect(() => {
    if (!cost) return;
    setDiesel(String(cost.dieselCentsPerGallon / 100));
    setOther(String(cost.otherCentsPerMile));
    setTarget(String(cost.targetCentsPerMile));
    setFloor(String(cost.floorCentsPerMile));
  }, [cost]);
  useUnsavedGuard(
    "settings-costs",
    !!cost &&
      (diesel !== String(cost.dieselCentsPerGallon / 100) ||
        other !== String(cost.otherCentsPerMile) ||
        target !== String(cost.targetCentsPerMile) ||
        floor !== String(cost.floorCentsPerMile)),
  );

  async function save() {
    if (!cost) return;
    const now = new Date().toISOString();
    const patch = {
      dieselCentsPerGallon: Math.round(Number(diesel) * 100),
      otherCentsPerMile: Number(other),
      targetCentsPerMile: Number(target),
      floorCentsPerMile: Number(floor),
    };
    await getSyncClient().mutate({
      entity: "cost_profile",
      op: "upsert",
      id: cost.id,
      baseVersion: cost.version || null,
      patch,
      row: { ...cost, ...patch, updatedAt: now },
    });
  }

  return (
    <div className="stack">
      <Link to="/settings" className="muted back-link">
        ← Settings
      </Link>
      <h1 className="screen-title">Costs</h1>
      <div className="card stack">
        <TextInput
          label="Diesel $/gal"
          placeholder="0.00"
          value={diesel}
          onChange={(e) => setDiesel(e.target.value)}
        />
        <TextInput
          label="Other ¢/mi"
          placeholder="30"
          value={other}
          onChange={(e) => setOther(e.target.value)}
        />
        <TextInput
          label="Target ¢/mi"
          placeholder="40"
          value={target}
          onChange={(e) => setTarget(e.target.value)}
        />
        <TextInput
          label="Floor ¢/mi"
          placeholder="100"
          value={floor}
          onChange={(e) => setFloor(e.target.value)}
        />
        <Button variant="primary" onClick={() => void save()}>
          Save
        </Button>
      </div>
    </div>
  );
}
